import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTest, fetchTestFilters, clearTest, clearTestQuestion, clearTestFilter } from 'app/actions/TestActions';
import { getTest, getIsLoadingTest, getTestFilter } from 'app/reducers';
import { Modal, Icon, Tooltip } from 'antd';

import IconButton from '@material-ui/core/IconButton';
import ApiService from 'app/services/ApiService';
import isEmpty from 'app/utils/IsEmpty';
import moment from 'moment';

export default function TableContainer(props) {
    const { confirm } = Modal;
    const pagination = props.pagination;
    const sorter = props.sorter;
    let offset = 0;
    let limit = 0;
    let column = null;
    let order = null;

    const { siteId } = useSelector(state => state.Auth);
    const { idSubdirection, employeeId } = useSelector(state => state.Auth.employeeById)

    const { classes } = props;
    const columns = [
        {
            title: 'Folio',
            dataIndex: 'testFolio',
            key: 'testFolio',
            sorter: true,
            width: 150
        }, {
            title: 'Folio Procedimiento',
            dataIndex: 'courseFolio',
            key: 'courseFolio',
            sorter: true,
            width: 173
        }, {
            title: 'Nombre',
            dataIndex: 'testTitle',
            key: 'testTitle',
            ellipsis: true,
            sorter: true,
            width: 300
        }, {
            title: 'Descripción',
            dataIndex: 'testDescription',
            key: 'testDescription',
            sorter: true,
            width: 450,
            ellipsis: true
        }, {
            title: 'Tipo de capacitación',
            dataIndex: 'trainingName',
            key: 'trainingName',
            sorter: true,
            width: 250,
        },
        {
            title: 'Fecha de Creación',
            dataIndex: 'creationDate',
            key: 'creationDate',
            sorter: true,
            width: 200,
            render: (creationDate) => {
                return moment(creationDate).locale('es').format('L')
            }
        },
        {
            title: 'Fecha de Modificación',
            dataIndex: 'modificationDate',
            key: 'modificationDate',
            sorter: true,
            width: 200,
            render: (courseDateCreation) => {
                return moment(courseDateCreation).locale('es').format('L')
            }
        }, {
            title: 'Preguntas',
            dataIndex: 'isConfigured',
            key: 'isConfigured',
            className: 'alignCenter',
            sorter: true,
            width: 150,
            render: hasQuestions => (
                hasQuestions ? <Icon type="check-circle" style={{ fontSize: '20px', color: '#5CBF69' }} /> : <Icon type="warning" style={{ fontSize: '20px', color: '#FFD600' }} />
            )
        }, {
            title: 'Estatus',
            dataIndex: 'statusName',
            key: 'statusName',
            sorter: true,
            width: 150,
        },
        {

        },
        {
            title: 'Acciones',
            dataIndex: 'idTest',
            key: 'actions',
            fixed: 'right',
            width: 120,
            render: (id, params) => (
                <div className={classes.buttons}>

                    {
                        siteId === 'HUB' ?
                            <Tooltip placement="bottomLeft" title={'Eliminar'}>
                                <IconButton className={classes.deleteIcon} onClick={() => showConfirmDelete(id)} disabled={params.statusName === 'ASIGNADO'}>
                                    <Icon type="delete" />
                                </IconButton>
                            </Tooltip>
                            :
                            null
                    }


                    <Tooltip placement="bottomLeft" title={siteId === 'HUB' ? 'Editar' : 'Visualizar'}>
                        <IconButton className={classes.editIcon} onClick={() => showTabEdit(id)}>
                            {
                                siteId === 'HUB' ?
                                    <Icon type="edit" />
                                    :
                                    <Icon type="eye" />
                            }
                        </IconButton>
                    </Tooltip>
                </div>
            )
        }
    ];

    const showTabEdit = (id, param) => {
        props.setTab('3')
        props.setIdTest(id)
        dispatch(clearTestQuestion());
        dispatch(clearTestFilter());
        dispatch(fetchTestFilters(idSubdirection, employeeId));
    }

    async function deleteEvaluation(id) {
        await ApiService.deleteTest(id).then(res => {
            dispatch(clearTest());
            dispatch(clearTestFilter());
            dispatch(fetchTestFilters(idSubdirection, employeeId));
            dispatch(fetchTest({ ...props.formData, subdirection: idSubdirection, EmployeeId: employeeId }));
        });
    }
    const showConfirmDelete = (id) => {
        let evaluation = evaluations.find(data => data['idTest'] === id);
        confirm({
            title: '¿Eliminar Evaluación?',
            content: evaluation.testTitle,
            okText: 'Eliminar',
            okType: 'danger',
            cancelText: 'Cancelar',
            onOk() {
                dispatch(clearTestFilter());
                dispatch(fetchTestFilters(idSubdirection, employeeId));
                return deleteEvaluation(id);
            },
            onCancel() { },
        });

    }

    let evaluations = useSelector(getTest);
    let isLoading = useSelector(getIsLoadingTest);
    let testFilter = useSelector(getTestFilter);

    const dispatch = useDispatch();

    useEffect(() => {
        if (isEmpty(evaluations)) fetchTestAction();
        if (isEmpty(testFilter)) fetchTestFilterAction();
    }, []);

    const handleTableChange = (pagination, filters, sorter) => {
        props.setPagination(pagination);
        props.setSorter(sorter);
        if (Object.keys(sorter).length > 0) {
            column = sorter.field;
            order = sorter.order === "ascend" ? "ASC" : "DESC";
        }
        else {
            column = '';
            order = '';
        }

        dispatch(fetchTest(
            {
                TestFolio: (props.formData.TestFolio === undefined) ? '' : props.formData.TestFolio,
                CourseFolio: (props.formData.CourseFolio === undefined) ? '' : props.formData.CourseFolio,
                TestTitle: (props.formData.TestTitle === undefined) ? '' : props.formData.TestTitle,
                ListStatus: (props.formData.ListStatus === undefined) ? '' : props.formData.ListStatus,
                ListTraining: (props.formData.ListTraining === undefined) ? '' : props.formData.ListTraining,
                InitialCreationDate: (props.formData.InitialCreationDate === undefined) ? '' : props.formData.InitialCreationDate,
                FinalCreationDate: (props.formData.FinalCreationDate === undefined) ? '' : props.formData.FinalCreationDate,
                InitialRevDate: (props.formData.InitialRevDate === undefined) ? '' : props.formData.InitialRevDate,
                FinalRevDate: (props.formData.FinalRevDate === undefined) ? '' : props.formData.FinalRevDate,
                subdirection: idSubdirection,
                EmployeeId: employeeId,
                sortColumn: column,
                sortDir: order,
                offset: ((pagination.current - 1) * pagination.pageSize),
                limit: pagination.pageSize
            }));
    };

    //Load
    if (pagination != null) {
        offset = (0 * pagination.pageSize);
        limit = (pagination.pageSize);

        if (!isLoading && evaluations.length > 0) {
            pagination.total = evaluations[0].totalcount;
        }
        else {
            pagination.total = 0;
        }
    }

    if (sorter != null) {
        column = sorter.field;
        order = sorter.order === "ascend" ? "ASC" : "DESC";
    }
    const fetchTestAction = () => dispatch(fetchTest({
        sortColumn: 'IdTest',
        sortDir: 'DESC',
        offset: offset,
        limit: limit,
        subdirection: idSubdirection,
        EmployeeId: employeeId

    }));
    const fetchTestFilterAction = () => dispatch(fetchTestFilters(idSubdirection, employeeId))
    evaluations.map(item => item['key'] = item.idTest);
    return (props.children({ pagination: pagination, cols: columns, evaluations, testFilter, isLoading, handleTableChange: handleTableChange }));
}